module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21.95 21.95\"><defs><style>.cls-1,.cls-2{fill:none;stroke:#FDCB47;}.cls-1{stroke-miterlimit:10;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}</style></defs><title>Fichier 6</title><g id=\"Calque_2\" data-name=\"Calque 2\"><g id=\"Calque_1-2\" data-name=\"Calque 1\"><circle class=\"cls-1\" cx=\"10.98\" cy=\"10.98\" r=\"10.48\"/><polyline class=\"cls-2\" points=\"4.45 8.81 11.01 15.37 17.5 8.88\"/></g></g></svg>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./src/assets/icons/icon-cookie.svg
// module id = FsI0
// module chunks = 1